var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-numeric"},[_c('span',{staticClass:"dashboard-numeric__amount",class:_vm.variantClass},[_vm._v(" "+_vm._s(_vm.formattedValue)+" ")]),_c('span',{staticClass:"dashboard-numeric__label"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }